import React, { useContext, useMemo } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { FiX } from "react-icons/fi";

function formatGbp(n) {
  const v = Number(n);
  if (Number.isNaN(v)) return "0";
  return v % 1 === 0 ? String(Math.round(v)) : v.toFixed(0);
}

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) =>
    productData.find((product) => product.id === id);

  const lines = useMemo(
    () =>
      cartItems
        .map((item) => {
          const product = getProductById(item.id);
          if (!product) return null;
          const unit = parseFloat(String(product.price).replace(/,/g, "")) || 0;
          return { item, product, unit, lineTotal: unit * item.quantity };
        })
        .filter(Boolean),
    [cartItems]
  );

  const itemCount = useMemo(
    () => cartItems.reduce((sum, i) => sum + i.quantity, 0),
    [cartItems]
  );

  const subtotal = useMemo(
    () => lines.reduce((sum, row) => sum + row.lineTotal, 0),
    [lines]
  );

  const decQuantity = (row) => {
    const { item } = row;
    if (item.quantity <= 1) {
      removeFromCart(item.id, item.size, item.color);
    } else {
      updateQuantity(item.id, item.size, item.color, item.quantity - 1);
    }
  };

  const incQuantity = (row) => {
    const { item } = row;
    updateQuantity(item.id, item.size, item.color, item.quantity + 1);
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-main">
        <div className="cart-inner">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <h1 className="cart-empty__title">SHOPPING BAG</h1>
              <p className="cart-empty__text">Your bag is empty.</p>
              <Link onClick={toTop} to="/shop" className="cart-empty__cta">
                Continue shopping
              </Link>
            </div>
          ) : (
            <div className="cart-layout">
              <div className="cart-bag">
                <div className="cart-bag__head">
                  <h1 className="cart-bag__title">SHOPPING BAG</h1>
                  <span className="cart-bag__count">
                    {itemCount} {itemCount === 1 ? "ITEM" : "ITEMS"}
                  </span>
                </div>

                <ul className="cart-list">
                  {lines.map((row) => (
                    <li
                      key={`${row.item.id}-${row.item.size}-${row.item.color}`}
                      className="cart-line"
                    >
                      <div className="cart-line__thumb">
                        <Link
                          onClick={toTop}
                          to={`/shopDetails/${row.product.id}`}
                        >
                          <img
                            src={row.product.image}
                            alt=""
                            className="cart-line__img"
                          />
                        </Link>
                      </div>
                      <div className="cart-line__info">
                        <Link
                          onClick={toTop}
                          to={`/shopDetails/${row.product.id}`}
                          className="cart-line__name"
                        >
                          {row.product.name}
                        </Link>
                        <p className="cart-line__spec">
                          Color: {row.item.color}
                        </p>
                        <p className="cart-line__spec">Size: {row.item.size}</p>
                      </div>
                      <div className="cart-line__qty-wrap">
                        <div className="cart-qty">
                          <button
                            type="button"
                            className="cart-qty__btn"
                            aria-label="Decrease quantity"
                            onClick={() => decQuantity(row)}
                          >
                            −
                          </button>
                          <span className="cart-qty__val">
                            {row.item.quantity}
                          </span>
                          <button
                            type="button"
                            className="cart-qty__btn"
                            aria-label="Increase quantity"
                            onClick={() => incQuantity(row)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className="cart-line__right">
                        <p className="cart-line__price">
                          ${formatGbp(row.lineTotal)}
                        </p>
                        <button
                          type="button"
                          className="cart-line__remove"
                          aria-label="Remove item"
                          onClick={() =>
                            removeFromCart(
                              row.item.id,
                              row.item.size,
                              row.item.color
                            )
                          }
                        >
                          <FiX />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <aside className="cart-sidebar">
                <div className="cart-summary">
                  <h2 className="cart-summary__heading">ORDER SUMMARY</h2>
                  <div className="cart-summary__row">
                    <span>Subtotal:</span>
                    <strong>${formatGbp(subtotal)}</strong>
                  </div>
                  <button
                    type="button"
                    className="cart-summary__checkout"
                    onClick={handleCheckout}
                  >
                    Checkout
                  </button>
                </div>
              </aside>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
